import React from 'react';
import NavBar from './NavBar.jsx';
import ReactDOM from 'react-dom';
import Ajax from "./AJAX.jsx";
import RecursiveField2 from "./RecursiveField2.jsx";
import InteractiveTable from './InteractiveTable.jsx';
import UpdateDataForm from './UpdateDataForm.jsx';
import ChangePositionView from './ChangePositionView.jsx';
import {DropDownMultiSelector} from "./DropDownSelector.jsx";
import DrawPosition from "./DrawPosition.jsx";
import * as tools from "./tools.jsx";
import {ConfirmModal} from "./ConfirmModal.jsx";
import {CompPlayer} from "./genericCompPlayer.js";

class PrefabAudioList extends React.Component {
     constructor(props)
   {
      super(props);
      
      //Set initial state
      this.state = {
         uploadsInProgress: [],
         data_contexts: [],
         data_prefabAudio: [],
         hasTriedReadingData: false,
      }
      
       this.extraBtns = [
         {name:'edit', click:this.clickedEdit.bind(this)},
         {name:'remove', click:this.clickedRemove.bind(this)},
         {name:"play", click:this.clickedPlay.bind(this)}
      ];

       this.compPlayer = new CompPlayer((msg)=>{this.props.appCallbacks.showMsg("Comp Player:", msg)});
     
   }
   
   componentWillUnmount()
   {
      this.compPlayer.tearDown();
   }

   clickedPlay(comp)
   {
      this.compPlayer.togglePlayComp({...comp, name:comp.title});
   }

   //fileupload->compositionPost cycle
   filesSelectedForUpload(e)
   {
      const self = this;
      //console.log(e.target.files);

      var nonConformingFilenames = [];

      for(var i = 0; i < e.target.files.length; i++)
      {
         const file = e.target.files[i];


         if(tools.stringHasNonStdAscii(file.name))
         {
            nonConformingFilenames.push(file.name);
            continue;
         }

         self.setState((prevState, props)=>{return{uploadsInProgress:[...prevState.uploadsInProgress, file]}});

         const fileUploaded = (response)=>
         {
            if(response.success)
            {
               //console.log("File Uploaded: " + file.name);
               //Remove file from uploading
               
               //Setup new standard composition
               const prefabAud =
               {
                  title:file.name,
                  file_name:response.result.onlineFileName,
                  author: "",
                  contexts: [],
               }

               const pAUploaded = (response)=>
               {
                  if(response.success)
                  {
                     self.forceRefreshData();
                  }
                  else
                  {
                     self.props.appCallbacks.showResponseErr(response, "Upload Prefab Audio Error");
                  }
                  self.setState((prevState, props)=>{return {uploadsInProgress:prevState.uploadsInProgress.filter((f)=>f!=file)}});

               }

               self.props.appCallbacks.performAjaxRequest('adminPrefabAudio', "POST", prefabAud, pAUploaded, false);
            }
            else
            {
               self.props.appCallbacks.showResponseErr(response, "File Upload Error");
            }
            
         } 

         self.props.appCallbacks.performAjaxRequest('audioFile', "POST", file, fileUploaded, true);
      }

      if(nonConformingFilenames.length > 0)
      {
         self.props.appCallbacks.showMsg("Unpermitted characters", "Files with names with special characters (could be æ,ø,å,´,` etc.) are not uploaded.\nFiles affected:\n"  + nonConformingFilenames.join("\n"));
      }
   }

   
   clickedEdit(pA)
   {
      const self = this;


      const onSaveEdit = function(editPA)
      {
         if(editPA != null)
         {         
            const donePuttingPA = (response) =>
            {
               if(response.success)
               {
                 self.props.appCallbacks.popModal();
                  self.forceRefreshData();
               }
               else
               {
                  self.props.appCallbacks.showResponseErr(response, "Edit Prefab Audio Error");
               }
            }
            //console.log("Putting comp: ", editedComp);
            self.props.appCallbacks.performAjaxRequest('adminPrefabAudio/' + pA.prefabAudio_id, "PUT", editPA, donePuttingPA, false);
         }
         else
         {
            self.props.appCallbacks.popModal();
         }
      }
      

      const contextObjects = self.state.data_contexts.map((con)=>{return({id:con.context_id, name:con.name});})
      
      const dataToEdit =
      {
         title:pA.title,
         author: pA.author,
         contexts: pA.contexts,
      }
      var modalProps = {
         saveCallback:onSaveEdit,
         heading:"Edit Prefab Audio Data",
         data:dataToEdit,
         drawFuncs:{contexts:DropDownMultiSelector},
         drawFuncObjects:{contexts:{objects:contextObjects}},
      };

      self.props.appCallbacks.pushModal({modalClass:UpdateDataForm, modalProps:modalProps});
      
   }


   clickedRemove(pA){
      const self = this;

      const onConfirmDelete = ()=>
      {
         const onServerDelete = (response)=>
         {
            if(response.success)
            {
               self.forceRefreshData();
            }
            else
            {
               self.props.appCallbacks.showResponseErr(response, "Remove Prefab Audio Error");
            }
         }

         self.props.appCallbacks.performAjaxRequest("adminPrefabAudio/" + pA.prefabAudio_id, "DELETE", null,
            onServerDelete, false);
      }

      const modalProps = {
         heading: "Confirm Delete",
         msg:"Delete Prefab Audio: " + pA.name + " ?",
         onConfirm:onConfirmDelete,
         popModal: self.props.appCallbacks.popModal,
      }
      self.props.appCallbacks.pushModal({modalClass:ConfirmModal, modalProps:modalProps});
   }

   readDataIfNotReadAndUserExists()
   {
     if(this.props.user)
      {
         if(!this.state.hasTriedReadingData)
         {

            this.props.appCallbacks.performAjaxRequest("adminPrefabAudio", "GET", null,
               tools.getSetBaseDataFunc(this, "data_prefabAudio"), false);

            this.props.appCallbacks.performAjaxRequest("contexts", "GET", null,
               tools.getSetBaseDataFunc(this, "data_contexts"), false);
            
            this.setState({hasTriedReadingData:true});
         }
      }
   }
    
   forceRefreshData() {
      this.setState({hasTriedReadingData:false});
      this.readDataIfNotReadAndUserExists();
   }

   componentWillUpdate()
   {
      this.readDataIfNotReadAndUserExists();
   }

   componentDidMount()
   {
      this.readDataIfNotReadAndUserExists();
   }

   getInterpreter()
   {
      const getContexts = (ids)=> ids.map((id)=>{return this.state.data_contexts.find((con)=>{return con.context_id == id;})});
     
      return (
      {
         contexts: (ids)=>{return getContexts(ids).map((con)=>{ return con ? con.name : "Non-existent";})},
      });
   }

   render() {

        return (
         <div>
            <div>
               <h1 style={{display:'inline-block'}}> Prefab Audio</h1>
               <div style={{float:"right", display: "inline-block", verticalAlign: "middle", lineHeight: 5}}>
                  Upload Files: <input type="file" id="fileUpload" multiple size = '10' accept=".aac" onChange={this.filesSelectedForUpload.bind(this)}/>
               </div>
            </div>
            <div>
               {this.state.data_prefabAudio.length/*state.publishedCompositions.length*/ == 0 ? null :
                  <InteractiveTable rowObjects={this.state.data_prefabAudio} interpreter={this.getInterpreter()}
                  extraBtns={this.extraBtns} hideColumns={["file_name"]}/> }
            </div>
         </div>
      );
   }
}

export default PrefabAudioList;


// WEBPACK FOOTER //
// ./js/PrefabAudioList.jsx